import { sendFetch, sendInfoManagerFetch, POST_OPTIONS, GET_OPTIONS } from './base.service';
import { getCompany } from '../_utils/storage_handler';

const BASE_PATH = '/maxminprices';

export const findAllMaxMinPrices = async () => {
    return await sendFetch(`${BASE_PATH}/all/company/${getCompany()}`, GET_OPTIONS);
}

export const createMaxMinPrices = async (body) => {
    return await sendFetch(`${BASE_PATH}/create`, POST_OPTIONS, body);
}